import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, MenuItemProps ,Dropdown} from 'semantic-ui-react'
import logo from '../../images/Tlogo.png'
import logo2 from '../../images/logoM1.png'
import './Header.css'
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import AnchorLink from 'react-anchor-link-smooth-scroll';
// import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; 
// import { Home } from '../Home/Home';
import { useMediaQuery } from 'react-responsive'

export enum TabNames {
    HOME = 'Home',
    COURCES = 'Courses',
    PRODUCTS = "Services",
    MOBILE = "Apply Job",
    CONTACT = "Contact",
    DEMO = "Demo",
    ABOUT_US = "About Us",
    LOGIN_PORTAL = "Login Portal"
}

export const Header = (props: {
    activeItem: TabNames,
    handleItemClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => void
}) => {
    const [open, setOpen] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: '(max-width: 900px)' })
    const [navBg, setNavBg] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); 
    // const [isMobile, setIsMobile] = useState(false);
    const handleDropdownToggle = () => {
        if (isMobile) {
            setIsDropdownOpen(!isDropdownOpen); // Toggle on click for mobile
        }
    };

    const changeNavBg = () => {
        window.scrollY >= 150 ? setNavBg(true) : setNavBg(false);
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNavBg);
        return () => {
            window.removeEventListener('scroll', changeNavBg);
        }
    }, [])

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }
    const scrollToTopS = () => {
        window.scrollTo(0, 700);
    }
    const scrollToTopA = () => {
        window.scrollTo(0, 1400);
    }



    return (
        <div className='top-bar'>
            
            <a className='logo-link' href='/'>
                {/* <img src={logo} alt='Tekcog' className='logo' /> */}
                <img src={logo2} alt='IntelleSphere' className='logo' />
                {/* <div className='footer__pvt'>Tekcog</div> */}
            </a>
            <div className='mobile-bar' onClick={() => {
                setOpen(!open)
            }}>
                
                <MenuIcon  className='iconMenu'></MenuIcon> 
                {/* <Icon name='bars' size='huge' /> */}
            </div>

            <Menu fixed='top' className={!navBg ? ('header-layout') : ('header-layout active')} stackable>
                <Menu.Menu
                    position='right'
                    className={open ? 'nav-bar-open' : 'nav-bar-hide'}
                >
             
                 <Dropdown
    item
    trigger={
        <span style={{display:'flex',justifyContent:'center'}}>
            Services{' '}
            {isDropdownOpen ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
        </span>
    }
    icon={null}
    className={props.activeItem === TabNames.PRODUCTS ? 'active' : ''}
    onMouseEnter={!isMobile ? () => setIsDropdownOpen(true) : undefined} // Open on hover for desktop
                    onMouseLeave={!isMobile ? () => setIsDropdownOpen(false) : undefined} // Close on hover for desktop
                    onClick={handleDropdownToggle} // Toggle on click for mobile
                    open={isDropdownOpen} 
>
    <Dropdown.Menu className="custom-dropdown-menu">
        <Dropdown.Item className="custom-dropdown-item"  as={Link} to="/product"  onClick={() => {scrollToTop(); setOpen(false)}}>
            Staffing
            {/* <KeyboardArrowUpOutlinedIcon /> */}
            </Dropdown.Item>
        <Dropdown.Item className="custom-dropdown-item" as={Link} to="/development" onClick={() => {scrollToTop(); setOpen(false)}}>Development</Dropdown.Item>
        <Dropdown.Item className="custom-dropdown-item" as={Link} to="/training" onClick={() => {scrollToTop(); setOpen(false)}}>Training</Dropdown.Item>
    </Dropdown.Menu>
</Dropdown>
                    
                 
                  
<Menu.Item
                        name={TabNames.COURCES}
                        active={props.activeItem === TabNames.COURCES}
                        // onClick={() => {
                        //     setOpen(!open)}}
                        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                            props.handleItemClick(event, data);
                            setOpen(false);
                            scrollToTopA();
                        }}
                        as={Link}
                        to='/training'
                    />
                    <Menu.Item
                        name={TabNames.ABOUT_US}
                        active={props.activeItem === TabNames.ABOUT_US}
                        // onClick={() => {
                        //     setOpen(!open)}}
                        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                            props.handleItemClick(event, data);
                            setOpen(false);
                            scrollToTop();
                        }}
                        as={Link}
                        to='/about-us'
                    />
                      <Menu.Item
                        name={TabNames.CONTACT}
                        active={props.activeItem === TabNames.CONTACT}
                      
                        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                            props.handleItemClick(event, data);
                            setOpen(false);
                            scrollToTop();
                        }}
                        as={Link}
                        to='/contact'
                    />
                     <Menu.Item
                        name={TabNames.LOGIN_PORTAL}
                        active={props.activeItem === TabNames.LOGIN_PORTAL}
                      
                        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps) => {
                            props.handleItemClick(event, data);
                            setOpen(false);
                            scrollToTop();
                        }}
                        as={Link}
                        to='/login-portal'
                    />
             
                

                </Menu.Menu>
            </Menu>

        </div>
    )
}